module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0ZGNTcyMiIgZD0iTTMyIDE1djI4SDEwYy0yLjIgMC00LTEuOC00LTRWMTVoMjZ6Ii8+PHBhdGggZmlsbD0iI0ZGQ0NCQyIgZD0iTTE0IDV2MzRjMCAyLjItMS44IDQtNCA0aDI5YzIuMiAwIDQtMS44IDQtNFY1SDE0eiIvPjxwYXRoIGQ9Ik0yMCAxMGgxOHY0SDIwem0wIDdoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHptLTEwIDRoOHYyaC04em0xMCAwaDh2MmgtOHoiIGZpbGw9IiNGRjU3MjIiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/news.svg
// module id = 4186
// module chunks = 0